<h2>Info</h2>
<h3>Color-coded tiles</h3>
<p>The tiles for the three strategic indicators are color-coded to show the variance of the displayed measure compared
  to the previous period. <em class="blue">Blue</em> indicates a positive sentiment, while <em class="red">red</em>
  indicates a negative sentiment. </p>
<h3>Arrows</h3>
<p>Arrow represents the change compared to the previous year:</p>
<div class="legend">
  <div class="blue">
    @for (style of [' filled', '']; track $index) {
    <div [class]="'arrow'+style">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <use [attr.xlink:href]="SvgSpriteIcon.ArrowUpLeft"></use>
      </svg>
    </div>
    }
    <span>blue arrow signifies a positive change</span>
  </div>
  <div class="red">
    @for (style of [' filled', '']; track $index) {
    <div [class]="'arrow'+style">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <use [attr.xlink:href]="SvgSpriteIcon.ArrowDownRight"></use>
      </svg>
    </div>
    }
    <span>red arrow signifies a negative change</span>
  </div>
</div>
